import React, { Children } from 'react'
import './index.scss'

const Locktext = (props) => {
    return (
        <div className='stat' style={{ width: '100%', height: props.height ? props.height : 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {props.showText ?
                <p className={`value ${props.className ? props.className : 'font-style-roboto'} ${props.textClass} ${props.showColorText ? (props.text <= 33 ? 'red' : props.text <= 66 ? 'yellow' : 'green') : ''}`}>{props.children || props.text}{props.showPercentage && props.text != '-' ? '%' : ''}</p>
                :
                <img className='lock-icon-img' src={props.LockIcon} alt="lock icon"></img>
            }
        </div>
    )
}

export default Locktext
